import { LanguagesCodes } from 'utils/enums/language';
import { MConfirmModalProps } from 'views/MConfirmModal/MConfirmModal.model';
import { MToastProps } from 'views/MToast/MToast.model';

import * as actions from '../actions/ui';

const initialState: State = {
  darkMode: false,
  themes: {
    fontFamily: null,
    dark: null,
    light: null,
  },
  asideShow: false,
  confirmModal: null,
  pageName: '',
  loadingSpinner: false,
  toast: null,
  language: null,
  hideRoiSimulation: true,
  displayGraphhopperSettings: false,
};

export const reducer = (state: State = initialState, action: actions.UITypes): State => {
  switch (action.type) {
    case actions.UIActions.SetTheme:
      return { ...state, darkMode: action.payload.type == 'dark' };
    case actions.UIActions.SetThemes:
      return { ...state, themes: action.payload.type };
    case actions.UIActions.SetAside:
      return { ...state, asideShow: action.payload.show };
    case actions.UIActions.ShowConfirmModal:
      return { ...state, confirmModal: action.payload };
    case actions.UIActions.HideConfirmModal:
      return { ...state, confirmModal: null };
    case actions.UIActions.ShowSpinner:
      return { ...state, loadingSpinner: action.payload.state };
    case actions.UIActions.showErrorToast:
      return { ...state, toast: action.payload };
    case actions.UIActions.showSuccessToast:
      return { ...state, toast: action.payload };
    case actions.UIActions.hideToast:
      return { ...state, toast: null };
    case actions.UIActions.SetLanguage:
      return { ...state, language: action.payload.type };
    case actions.UIActions.SetHideRoiSimulation:
      return { ...state, hideRoiSimulation: action.payload.hide };
    case actions.UIActions.SetDisplayGraphhopperSettings:
      return { ...state, displayGraphhopperSettings: action.payload.display };
    default:
      return state;
  }
};

export type State = {
  darkMode: boolean;
  themes: {
    fontFamily?: string | null;
    dark: { [key: string]: string } | null;
    light: { [key: string]: string } | null;
  };
  asideShow: boolean;
  confirmModal: MConfirmModalProps | null;
  pageName: string;
  loadingSpinner: number | boolean;
  toast: MToastProps | null;
  language: LanguagesCodes | null;
  hideRoiSimulation: boolean;
  displayGraphhopperSettings: boolean;
};
